/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BedOccupancyStatsResponse } from './BedOccupancyStatsResponse';
import {
    BedOccupancyStatsResponseFromJSON,
    BedOccupancyStatsResponseFromJSONTyped,
    BedOccupancyStatsResponseToJSON,
} from './BedOccupancyStatsResponse';

/**
 * 
 * @export
 * @interface GetFacilityBedOccupancyStats200Response
 */
export interface GetFacilityBedOccupancyStats200Response {
    /**
     * 
     * @type {BedOccupancyStatsResponse}
     * @memberof GetFacilityBedOccupancyStats200Response
     */
    data?: BedOccupancyStatsResponse;
}

/**
 * Check if a given object implements the GetFacilityBedOccupancyStats200Response interface.
 */
export function instanceOfGetFacilityBedOccupancyStats200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetFacilityBedOccupancyStats200ResponseFromJSON(json: any): GetFacilityBedOccupancyStats200Response {
    return GetFacilityBedOccupancyStats200ResponseFromJSONTyped(json, false);
}

export function GetFacilityBedOccupancyStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacilityBedOccupancyStats200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : BedOccupancyStatsResponseFromJSON(json['data']),
    };
}

export function GetFacilityBedOccupancyStats200ResponseToJSON(value?: GetFacilityBedOccupancyStats200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': BedOccupancyStatsResponseToJSON(value.data),
    };
}

